import { render, staticRenderFns } from "./ItemizedInvoicesTable.vue?vue&type=template&id=3348057e&scoped=true"
import script from "./ItemizedInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ItemizedInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./ItemizedInvoicesTable.vue?vue&type=style&index=0&id=3348057e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3348057e",
  null
  
)

export default component.exports